import Profiles from "components/Profiles";
import Main from "layouts/Main";


function SettingsPage() {

  return (
    <>
    <Main namePage="ตั้งค่า"  >
      <div className="layout-content">
        <Profiles />
      </div>
      </Main>
    </>
  );
}

export default SettingsPage;